import { EventBus } from "@/event-bus.js";

export default class messageBox {
    static confirm(title, message, callback) {
        EventBus.$emit("messagebox", "confirm", title, message, null, callback);
    }

    static prompt(title, promptFields, callback) {
        EventBus.$emit("messagebox", "prompt", title, null, promptFields, callback);
    }
}
